

<app-form-input 
[parentForm]="parentForm" 
[disabled]="disabled"
[value]="delais?.receptCandidatures" 
[label]="step10.getreceptcandidatures"
[type]="'datetime'" [rule]="''"
[name]="getUid()+'_SepAtt_receptCandidatures'">
</app-form-input>
<app-form-input-error [activeForm]="parentForm" [name]="getStepId() + rg1" [id]="getStepId() + rg1"></app-form-input-error>
<app-form-input-error [activeForm]="parentForm" [name]="getStepId() + rg2" [id]="getStepId() + rg2"></app-form-input-error>
<app-form-input-error [activeForm]="parentForm" [name]="getStepId() + rg9" [id]="getStepId() + rg9"></app-form-input-error>

<app-form-input 
[parentForm]="parentForm" 
[disabled]="disabled"
[value]="delais?.receptionOffres" 
[label]="step10.getreceptoffres"
[type]="'datetime'" [rule]="''"
[name]="getUid()+'_SepAtt_receptionOffres'">
</app-form-input>
<app-form-input-error [activeForm]="parentForm" [name]="getStepId() + rg3" [id]="getStepId() + rg3"></app-form-input-error>
<app-form-input-error [activeForm]="parentForm" [name]="getStepId() + rg4" [id]="getStepId() + rg4"></app-form-input-error>
<app-form-input-error [activeForm]="parentForm" [name]="getStepId() + rg6" [id]="getStepId() + rg6"></app-form-input-error>
<app-form-input-error [activeForm]="parentForm" [name]="getStepId() + rg7" [id]="getStepId() + rg7"></app-form-input-error>

 <app-form-input 
[parentForm]="parentForm" 
[disabled]="disabled"
[value]="delais?.envoiInvitation" 
[label]="step10.getenvoiinvitation"
[type]="'date'" [rule]="'pattern_7'"
[errorMessage]="{'pattern' : 'ctr_pattern7'}"
[name]="getUid()+'_SepAtt_envoiInvitation'">
</app-form-input>
<app-form-input-error [activeForm]="parentForm" [name]="getStepId() + rg5" [id]="getStepId() + rg5"></app-form-input-error>
<app-form-input-error [activeForm]="parentForm" [name]="getStepId() + rg8" [id]="getStepId() + rg8"></app-form-input-error>

<app-validite  [uid]="getUid()" [parentForm]="parentForm" [validite]="delais?.validite"></app-validite>
